// The metronome (design §7 Tools): the §12 timing engine's click, with tap
// tempo, meter and accent presets and a count-in.
export const id = 'metronome';
export const name = 'Metronome';
export const purpose = 'Keep time with a click in any meter, including odd groupings.';
export const icon = '♩';
export const order = 20;
